import { Plus, X } from "lucide-react";

export const DAYS = [
  ["MONDAY", "Lundi"], ["TUESDAY", "Mardi"], ["WEDNESDAY", "Mercredi"], ["THURSDAY", "Jeudi"],
  ["FRIDAY", "Vendredi"], ["SATURDAY", "Samedi"], ["SUNDAY", "Dimanche"],
];
const DEFAULT_PERIOD = { open: "08:00", close: "18:00" };

export function GbpHoursEditor({ hours, onChange }) {
  const byDay = (day) => hours.filter((h) => h.day === day);
  const setDay = (day, periods) => onChange([...hours.filter((h) => h.day !== day), ...periods.map((p) => ({ day, ...p }))]);
  const copyMonday = () => {
    const mon = byDay("MONDAY").map(({ open, close }) => ({ open, close }));
    const rest = hours.filter((h) => !["TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY"].includes(h.day));
    onChange([...rest, ...["TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY"].flatMap((d) => mon.map((p) => ({ day: d, ...p })))]);
  };

  return (
    <div className="space-y-1.5" data-testid="gbp-hours-editor">
      {DAYS.map(([day, label]) => {
        const periods = byDay(day);
        const open = periods.length > 0;
        return (
          <div key={day} className="flex items-start gap-3 text-xs" data-testid={`gbp-hours-${day}`}>
            <label className="w-28 flex items-center gap-2 pt-1.5 font-medium text-slate-800 cursor-pointer">
              <input
                type="checkbox"
                checked={open}
                onChange={(e) => setDay(day, e.target.checked ? [DEFAULT_PERIOD] : [])}
                data-testid={`gbp-hours-open-${day}`}
                className="accent-[#002FA7]"
              />
              {label}
            </label>
            <div className="flex-1 flex flex-col gap-1">
              {!open ? (
                <span className="text-slate-400 pt-1.5" data-testid={`gbp-hours-closed-${day}`}>Fermé</span>
              ) : periods.map((p, i) => (
                <div key={i} className="flex items-center gap-1.5">
                  <input type="time" value={p.open} data-testid={`gbp-hours-${day}-open-${i}`}
                    onChange={(e) => setDay(day, periods.map((q, k) => (k === i ? { ...q, open: e.target.value } : q)))}
                    className="border border-slate-300 rounded px-1.5 py-1 bg-white" />
                  <span className="text-slate-400">→</span>
                  <input type="time" value={p.close === "24:00" ? "23:59" : p.close} data-testid={`gbp-hours-${day}-close-${i}`}
                    onChange={(e) => setDay(day, periods.map((q, k) => (k === i ? { ...q, close: e.target.value } : q)))}
                    className="border border-slate-300 rounded px-1.5 py-1 bg-white" />
                  {periods.length > 1 && (
                    <button onClick={() => setDay(day, periods.filter((_, k) => k !== i))} data-testid={`gbp-hours-${day}-remove-${i}`}
                      className="text-slate-400 hover:text-red-600" title="Retirer cette plage"><X className="w-3.5 h-3.5" /></button>
                  )}
                  {i === periods.length - 1 && periods.length < 3 && (
                    <button onClick={() => setDay(day, [...periods, { open: "14:00", close: "18:00" }])} data-testid={`gbp-hours-${day}-add`}
                      className="inline-flex items-center gap-0.5 text-[#002FA7] hover:underline ml-1"><Plus className="w-3 h-3" /> plage</button>
                  )}
                </div>
              ))}
            </div>
          </div>
        );
      })}
      <button onClick={copyMonday} disabled={byDay("MONDAY").length === 0} data-testid="gbp-hours-copy-monday"
        className="text-[11px] text-[#002FA7] hover:underline disabled:opacity-40 disabled:no-underline mt-1">
        Appliquer les horaires du lundi à mardi → vendredi
      </button>
    </div>
  );
}
